export const Marquee = ({ dark = false }) => {
  const text = "More Than Building, We Transform.";
  const items = Array.from({ length: 6 });
  return (
    <div
      className={`overflow-hidden py-8 md:py-12 ${dark ? "bg-navy-dark" : "bg-cloud"}`}
      data-testid="marquee"
      aria-hidden="true"
    >
      <div className="marquee-track">
        {items.map((_, i) => (
          <span
            key={i}
            className={`font-display font-bold uppercase text-6xl md:text-8xl px-8 tracking-tight ${
              dark ? "text-outline-white" : "text-outline-navy"
            }`}
          >
            {text}
            <span className={dark ? "text-gold" : "text-gold"}> ✦ </span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
